"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDone = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./confirm.scss");
var react_i18next_1 = require("react-i18next");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var ConfirmDone = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var chain = (0, react_redux_1.useSelector)(function (state) { return ({
        chain: state.app.chain,
    }); }).chain;
    var toMenu = function () {
        var prevParams = Object.fromEntries(searchParams);
        if (prevParams.key) {
            delete prevParams.key;
        }
        var URLParams = new URLSearchParams(prevParams);
        history.push({ pathname: "/store/".concat(restaurantId), search: URLParams.toString() });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm-container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "card" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "card-title" }, { children: [t('Thank you for visiting'), " ", (chain === null || chain === void 0 ? void 0 : chain.name) || '', "!"] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "card-description" }, { children: t("We hope to see you again soon!") })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "custom-button confirm-button", onClick: toMenu }, { children: t('back to menu') }))] })) })));
};
exports.ConfirmDone = ConfirmDone;
